
//This function currently isn't dependent on feature flags, but once we make it so the carded trial to signup process

import { getAmenActivPreferences_2scale, getAmenActivPreferences_5scale, send_setPreferences } from "../page-scripts/settings_scripts";

//is integrated, we will want to have it leverage feature flags then
export function freemiumShowSignup(element: JQuery<HTMLElement>){
    let msg:string|undefined|null = $(element).attr("msg");
    let level:number|undefined|null = parseInt($(element).attr("level"))

    if (msg === undefined || msg === null) {
      msg = "Create a free account to start planning with our basic features!";
    }else{
      if (level == 2){
        msg = msg.replace(",", "") + " requires a Pro account, but first";
      }else{
        msg = msg;
      }
    };

    if(window.featureFlags.freeTrialState == "carded"){
        if (level == 2){
            $("#signUp_cardedTrialModal").find("[signUpMsg]").html(msg);
            $("#signUp_cardedTrialModal").modal("show");
            try{
                //Google Analytics signup tracking (see how many times modal has opened)
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({'event': 'showMemberSignup', 'showMemberSignupParameters':{'carded':'true', 'message' : msg, 'page':window.location.href}});
            } catch (error){
            console.error(error.message)
            }
        }else{
            $("#signupModal").find("[signUpMsg]").html(msg);
            $("#signupModal").modal("show");
            try{
                //Google Analytics signup tracking (see how many times modal has opened)
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({'event': 'showMemberSignup', 'showMemberSignupParameters':{'carded':'false', 'message' : msg, 'page':window.location.href}});
            } catch (error){
            console.error(error.message)
            }
        }
    }else{
        $("#signupModal").find("[signUpMsg]").html(msg);
        $("#signupModal").modal("show");
        try{
           //Google Analytics signup tracking (see how many times modal has opened)
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({'event': 'showMemberSignup', 'showMemberSignupParameters':{'carded':'false', 'message' : msg, 'page':window.location.href}});
        } catch (error){
        console.error(error.message)
        }
    }
}

export function freemiumShowSubscribe(element: JQuery<HTMLElement>){
    let msg:string|undefined|null = $(element).attr("msg");
    let level:number|undefined|null = parseInt($(element).attr("level"))

    if (msg === undefined || msg === null) {
        msg = "Subscribe to start planning awesome adventures!";
    }else{
        msg = msg + " purchase AdventureGenie Pro!";
    };


    $("#freemium-subscribe").find("[signUpMsg]").html(msg);
    $("#freemium-subscribe").modal("show");
    try{
        //Google Analytics subscribe tracking (see how many times modal has opened)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'event': 'showSubscribeSignup', 'showSubscribeSignupParameters':{'trial':'false', 'message' : msg, 'page':window.location.href}});
    } catch (error){
        console.error(error.message)
    };
}


export function submitPreferenceSettings(element: JQuery<HTMLElement>){
    let userInterests:string = $("#account-interests").val() as string;

    let checkedAmenityIDs:Array<{
            ID:number,
            weight:number
    }>;
    let checkedActivityIDs:Array<{
            ID:number,
            weight:number
    }>;

    let preferences:any;
    if (window.featureFlags.preferencesNumOptions == 2) {
        preferences = getAmenActivPreferences_2scale();
    } else {
        preferences = getAmenActivPreferences_5scale();
    };
    checkedAmenityIDs = preferences["amenities"];
    checkedActivityIDs = preferences["activities"];

    let min_p:number = parseInt($("#rs-min").val().toString());
    let max_p:number = parseInt($("#rs-max").val().toString());
    let set_p:boolean = $("#price-is-set").prop("checked");

    // Call the function to update the user's preferences
    $("#save-pref-spinner").show();
    send_setPreferences(checkedAmenityIDs, checkedActivityIDs, min_p, max_p, set_p, userInterests).then((response) => {
        let oldAcctCompletion:number = parseInt($(".progress-circle").attr("stroke-dashoffset").toString());
        $(".progress-circle").each(function() {
            $(element).attr("stroke-dashoffset",response.dashoffset);
        });

        if (parseInt(response.dashoffset) < oldAcctCompletion) {
            $("#prefsComplete").removeClass("ai-circle-x");
            $("#prefsComplete").addClass("ai-circle-check-filled");
            $("#prefsComplete").css({"color":"#FF7700"});
        } else if (parseInt(response.dashoffset) > oldAcctCompletion) {
            $("#prefsComplete").removeClass("ai-circle-check-filled");
            $("#prefsComplete").addClass("ai-circle-x");
            $("#prefsComplete").css({"color":""});
        };

        $("#acctCompletionMsg").html("Your account is " + response.completionPercentage + "% complete!")
        setTimeout(function(){$("#save-pref-spinner").hide()},500);
    }).catch((e) => {
            console.error("Error updating preferences: ", e);
            const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
            $("#errorModal").modal("show");
    });
}